import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBInput, MDBRadio, MDBSpinner } from "mdb-react-ui-kit";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from "../../Core/Service/ApiService";
import { SketchPicker } from "react-color";
import LoadingIndicator from "../../Components/LoadingIndicator/LoadingIndicator";
import ImageUploader from "../../Components/ImageUploader/ImageUploader";

const TemplateEdit = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        internal_name: '',
        background: {
            bg_color: '#fff',
        },
    })
    const [inputErrors, setInputErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const [showColorPicker, setShowColorPicker] = useState({
        bg_color: false,
    });

    const loadData = async () => {
        if (params.action == 'edit' || params.action == 'copy' || params.action == 'view') {
            setLoading(true);

            const response = await ApiService.get(`/templates/${params.id}`)
            setFormData({
                internal_name: response.data.template.internal_name,
                background: JSON.parse(response.data.template.background ?? '')
            })

            setLoading(false);
        } else {
            
        }
    }

    useEffect(()=>{
        loadData();
    }, []);

    const handleInternalNameChange = (e) => {
        setFormData({
            ...formData,
            internal_name: e.target.value
        })
    }

    const toggleShowColorPicker = (color_target) => {
        setShowColorPicker({
            ...showColorPicker,
            [color_target]: !showColorPicker[color_target]
        })
    }
    const hideShowColorPicker = (color_target) => {
        setShowColorPicker({
            [color_target]: false,
        })
    }
    const handleBackgroundColorChange = (target, color) => {
        setFormData({
            ...formData,
            background: {
                ...formData.background,
                [target]: color.hex
            }
        })
    }
    const setBackgroundImage = (patch) => {
        setFormData(prev => ({
            ...prev,
            background: {
                ...prev.background,
                image: {
                    type: 'image',
                    ...(prev.background?.image ?? {}),
                    ...patch,
                }
            }
        }))
    }
    const handleBgImageLinkTypeChange = (active_link) => setBackgroundImage({ active_link });
    const handleBgImageExternalChange = (e) => setBackgroundImage({ external_link: e.target.value });
    const onBgImageUploaded = (id, upload_file) => setBackgroundImage({ active_link: 'upload', upload_file });
    const onBgImageDeleted = () => setBackgroundImage({ upload_file: '' });
    const goBack = () => {
        navigate(-1);
    }

    const handleSave = async () => {
        const data = {
            internal_name: formData.internal_name,
            background: JSON.stringify(formData.background),
        }

        setSaving(true);

        if(params.action === 'edit') {
            await ApiService.put(`/templates/${params.id}`, data);
        } else {
            await ApiService.post('/templates', data);
        }

        navigate('/template/list');
        setSaving(false);
    }

    const renderCommon = () => {
        return (
        <MDBCard>
            <MDBCardHeader>
                <MDBCardTitle>Common</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <div className="d-flex">
                    <div>
                        <label>Internal Name:</label>
                        <div style={{width: 300}}>
                            <MDBInput name='internal_name' onChange={handleInternalNameChange} value={formData.internal_name} />
                        </div>
                    </div>
                </div>
            </MDBCardBody>
        </MDBCard>
        )
    }

    const renderBackground = () => {
        return (
        <MDBCard className="mt-4">
            <MDBCardHeader>
                <MDBCardTitle>Background</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <div className="d-flex">
                    <div className="d-flex">
                        <label className="me-2">Background Color:</label>
                        <div className="d-flex align-items-center">
                        <div className="color-picker">
                            <div className="swatch" onClick={() => toggleShowColorPicker('bg_color')}>
                                    <div className="color" style={{ background: formData.background?.bg_color }}></div>
                                </div>
                                {showColorPicker.bg_color && <div className="picker-popover ms-2 mt-1">
                                    <div className="cover" onClick={() => hideShowColorPicker('bg_color')} />
                                    <SketchPicker color={formData.background?.bg_color} onChange={(color) => handleBackgroundColorChange('bg_color', color)} />
                                </div>}
                            </div>
                            <div className="ms-2">{formData.background?.bg_color}</div>
                        </div>
                    </div>
                </div>

                <div className="mt-4">
                    <label className="me-2">Background Image (optional):</label>
                    <div className="mt-2" style={{ maxWidth: 400 }}>
                        <div>
                            <MDBRadio name="bg_image_link_type" label="External Link"
                                checked={formData.background?.image?.active_link == 'external'}
                                onChange={() => handleBgImageLinkTypeChange('external')} />
                            <MDBInput
                                className={formData.background?.image?.active_link == 'external' ? '' : 'disabled'}
                                value={formData.background?.image?.external_link ?? ''}
                                onChange={handleBgImageExternalChange}
                            />
                        </div>
                        <div className="mt-2">
                            <MDBRadio name="bg_image_link_type" label="Upload Image"
                                checked={formData.background?.image?.active_link == 'upload'}
                                onChange={() => handleBgImageLinkTypeChange('upload')} />
                            <ImageUploader
                                id="bg_image"
                                className={formData.background?.image?.active_link == 'upload' ? '' : 'disabled'}
                                onImageUploaded={onBgImageUploaded}
                                onImageDeleted={onBgImageDeleted}
                                defaultSrc={formData.background?.image?.upload_file}
                                folder="web"
                            />
                        </div>
                    </div>
                </div>
            </MDBCardBody>
        </MDBCard>
        )
    }

    return (
    <div className="template-edit p-4">
        { renderCommon() }

        {renderBackground()}

        <div className="d-flex mt-4 justify-content-end">
            <MDBBtn className="me-4" color="default" onClick={goBack}>Back</MDBBtn>
            <MDBBtn className="united-cms-primary-btn" onClick={handleSave}>
                {saving && <MDBSpinner size="sm" className="me-1" />}
                Save
            </MDBBtn>
        </div>

        <LoadingIndicator show={loading} fullScreen={true} />
    </div>
    )
}

export default TemplateEdit;